"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightTheme = exports.darkTheme = void 0;
const global = {
    media: {
        xs: '@media (max-width: 480px)',
        sm: '@media (max-width: 800px)',
        md: '@media (max-width: 1040px)',
        lg: '@media (max-width: 1300px)',
        xl: '@media (min-width: 1301px)',
    },
    radius: {
        xs: '20px',
        sm: '20px',
        md: '25px',
        lg: '25px',
        xl: '30px'
    },
    spacing: {
        gap: { sm: '15px', md: '20px' },
        margin: { xs: "10px", sm: '15px', md: '20px', lg: '30px', xl: '30px' },
        page: { xs: "10px", sm: '15px', md: '20px', lg: '40px', xl: '50px' }
    }
};
exports.darkTheme = {
    colors: {
        bg: '#161819',
        onBg: '#FFFFFF',
        contrastBg: '#0D0E0E',
        altBg: '#0D0E0E',
        onAltBg: '#FFFFFF',
        onContrastBg: '#86858A',
        gradientBg: "linear-gradient(65deg,hsl(240deg 3% 7%) 0%,hsl(225deg 7% 10%) 7%,hsl(215deg 12% 12%) 16%,hsl(208deg 17% 13%) 31%,hsl(202deg 21% 15%) 58%,hsl(197deg 25% 16%) 82%,hsl(191deg 28% 18%) 92%,hsl(186deg 29% 19%) 96%,hsl(179deg 28% 20%) 99%,hsl(172deg 27% 22%) 100%,hsl(163deg 25% 25%) 100%);",
        border: '#363636',
        chartsBg: '#0D0E0E',
        charts: [
            '#FB7474',
            '#0AB57F',
            '#C23983',
            '#74B4EF',
            '#9474EF',
            '#E1331B',
            '#1C768A',
            '#A7C763',
            '#962E2E',
        ],
        table: {
            text: '#86858A ',
            odd: '#151718',
            even: "#161819",
            hover: '#0d0e0e',
            header: '#1A1D1E'
        },
        sectionTitle: {
            bg: '#363636',
            onBg: '#fff',
        }
    },
    ...global,
};
exports.lightTheme = {
    colors: {
        bg: '#F9FAFE',
        altBg: '#fff',
        onBg: '#161819',
        gradientBg: 'linear-gradient(40deg,hsl(240deg 15% 89%) 3%,hsl(236deg 20% 89%) 22%,hsl(232deg 25% 89%) 33%,hsl(229deg 30% 89%) 43%,hsl(226deg 36% 89%) 53%,hsl(223deg 41% 89%) 63%,hsl(221deg 47% 89%) 75%,hsl(219deg 53% 88%) 96%)',
        contrastBg: '#5d627b',
        onContrastBg: '#fff',
        onAltBg: '#161819',
        border: '#E1E1E1',
        table: {
            text: '#86858A',
            odd: '#F9FAFE',
            even: "#f1f1f3",
            hover: '#E2E1E9',
            header: '#F0F1F6'
        },
        sectionTitle: {
            bg: '#5d627b',
            onBg: '#fff',
        },
        chartsBg: '#fff',
        charts: [
            '#0AB57F',
            '#FB7474',
            '#74B4EF',
            '#9474EF',
            '#C23983',
            '#B50A66',
            '#E1331B',
            '#1C768A',
            '#A7C763',
            '#962E2E',
        ]
    },
    ...global,
};
